import { useSelector } from "store/useSelector";

// separate file to avoid circular imports
export const useIsStorybook = (): boolean =>
  useSelector(state => state.legacy.isStorybook);
